exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.full-block {\n  display: block;\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.content-wrapper .scroll-wrapper .scroll-x {\n  display: none;\n}\n.content-wrapper .scroll-wrapper .scroll-y {\n  height: 98%;\n  min-height: 98%;\n  right: 6px;\n  top: 1%;\n}\n", ""]);

// exports
